<!--<template>-->
<!--  <v-app app>-->
<!--    <div ref="container" class="mb-7 light6 main-container">-->
<!--      <router-view />-->
<!--    </div>-->
<!--    <ad-footer v-if="$route.name != 'PrintApplication'" class="d-print-none"></ad-footer>-->
<!--  </v-app>-->
<!--</template>-->




<template>
  <v-app app>
    <v-main ref="container" class=" light6">
      <router-view />
    </v-main>
    <ad-footer v-if="$route.name != 'PrintApplication'" class="d-print-none"></ad-footer>
  </v-app>
</template>



<script>
import Vue from "vue";
import Footer from "./components/layout/Footer.vue";
import serverTranslationsMixin from "@/mixins/serverTranslations.js";
export default Vue.extend({
  name: "App",
  components: {
    "ad-footer": Footer
  },
  mixins: [serverTranslationsMixin],
  created() {
    this.getUniversityData();
  },
  methods: {
    getUniversityData() {
      fetch("/api/general_data/foundation_details/", {})
        .then(res => res.json())
        .then(data => {
          localStorage.setItem("title", data.name);
          localStorage.setItem("logo", data.logo);
          localStorage.setItem("foundationId", data.id);
          localStorage.setItem("backgroundColorRight", data.backgroundColorRight);
          localStorage.setItem("fontColorRight", data.fontColorRight);
           localStorage.setItem("backgroundColorLeft", data.backgroundColorLeft);
          localStorage.setItem("fontColorLeft", data.fontColorLeft);
          localStorage.setItem("backgroundColorButton", data.backgroundColorButton);
           localStorage.setItem("logoImageClass", data.logoImageClass);
          localStorage.setItem("backgroundImage", data.backgroundImage);
          localStorage.setItem("termsFilePath", data.termsFilePath);
          localStorage.setItem("universityHRID", data.hrID);
            // new part ///

          localStorage.setItem(
                "loginPageBackground",
                data.loginPageBackground || "#F5F8FC"
              );

          localStorage.setItem(
                "loginLeftBackground",
                data.loginLeftBackground || "#0B2D6B"
              );

          localStorage.setItem(
                "loginLeftText",
                data.loginLeftText || "#FFFFFF"
              );

          localStorage.setItem(
                "loginLeftSubtitle",
                data.loginLeftSubtitle || "#D9B35A"
              );

          localStorage.setItem(
                "loginRightBackground",
                data.loginRightBackground || "#FFFFFF"
              );

          localStorage.setItem(
                "loginTitleColor",
                data.loginTitleColor || "#0B2D6B"
              );

          localStorage.setItem(
                "loginSubtitleColor",
                data.loginSubtitleColor || "#16B5C3"
              );

          localStorage.setItem(
                "loginInputBorder",
                data.loginInputBorder || "#D8DDE6"
              );

          localStorage.setItem(
                "loginInputText",
                data.loginInputText || "#6B7280"
              );

          localStorage.setItem(
                "loginButtonGradientStart",
                data.loginButtonGradientStart || "#12B4C2"
              );

          localStorage.setItem(
                "loginButtonGradientEnd",
                data.loginButtonGradientEnd || "#18A9B7"
              );

          localStorage.setItem(
                "loginButtonText",
                data.loginButtonText || "#FFFFFF"
              );

          localStorage.setItem(
                "loginLinkColor",
                data.loginLinkColor || "#16B5C3"
              );

          localStorage.setItem(
                "loginCardShadow",
                data.loginCardShadow || "0 20px 50px rgba(0,0,0,.08)"
              );
          localStorage.setItem(
    "loginDividerIcon",
    data.loginDividerIcon || "mdi-school"
);

localStorage.setItem(
    "loginDividerColor",
    data.loginDividerColor || "#D9B35A"
);

localStorage.setItem(
    "loginDividerWidth",
    data.loginDividerWidth || "120px"
);

localStorage.setItem(
    "loginButtonBorderRadius",
    data.loginButtonBorderRadius || "8px"
);

localStorage.setItem(
    "loginButtonMinWidth",
    data.loginButtonMinWidth || "250px"
);

localStorage.setItem(
    "loginButtonTextColor",
    data.loginButtonTextColor || "#FFFFFF"
);

localStorage.setItem(
    "loginUsernameIcon",
    data.loginUsernameIcon || "mdi-account-outline"
);

localStorage.setItem(
    "loginPasswordIcon",
    data.loginPasswordIcon || "mdi-lock-outline"
);

localStorage.setItem(
    "loginRegisterIcon",
    data.loginRegisterIcon || "mdi-account-plus-outline"
);

localStorage.setItem(
    "loginForgotPasswordIcon",
    data.loginForgotPasswordIcon || "mdi-lock-reset"
);

localStorage.setItem(
    "loginLanguageIcon",
    data.loginLanguageIcon || "mdi-web"
);

localStorage.setItem(
    "loginResetMailIcon",
    data.loginResetMailIcon || "mdi-email-sync-outline"
);

                        ////

          this.$store.commit("setUniversity", data);

          this.setTitleAndLogo(data);
        });
    },
    setTitleAndLogo(data) {
      const title = `${this.$t("SYSTEM_NAME")} ${data.name}`;
      document.title = this.serverTranslate(title);
    }
  }
});
</script>
<style type="text/css3">
.v-btn {
  text-transform: none !important;
}
</style>
